import React from "react";

export const MONTHLY_PHONE_REPORT_TABS = [
  {
    id: "patientOutreach",
    label: "Patient Outreach Status",
    sublabel: "Who has met consultation requirements",
    icon: "mdi-account-group-outline",
    helpTitle: "Patient outreach report"
  },
  {
    id: "teamPerformance",
    label: "Team Member Performance",
    sublabel: "Consultations by staff & providers",
    icon: "mdi-account-supervisor-outline",
    helpTitle: "Team performance report"
  }
];

const MonthlyPhoneReportNav = ({ activeReportTab, onChange, counts = {} }) => (
  <div className="mpc-report-subnav-shell" role="tablist" aria-label="Monthly phone consultation reports">
    <div className="mpc-report-subnav-intro">
      <h5>Choose a report</h5>
      <p>Each sub-report uses the same month filter above and answers a different question about monthly phone consultations.</p>
    </div>
    <div className="mpc-report-subnav">
      {MONTHLY_PHONE_REPORT_TABS.map((tab) => {
        const count = counts[tab.id];
        const isActive = activeReportTab === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`mpc-report-tab-${tab.id}`}
            aria-controls={`mpc-report-panel-${tab.id}`}
            aria-selected={isActive}
            className={`mpc-report-subnav-item ${isActive ? "active" : ""}`}
            onClick={() => onChange(tab.id)}
          >
            <span className={`mpc-report-subnav-icon ${isActive ? "active" : ""}`} aria-hidden="true">
              <i className={`mdi ${tab.icon}`} />
            </span>
            <span className="mpc-report-subnav-copy">
              <span className="mpc-report-subnav-label">{tab.label}</span>
              <span className="mpc-report-subnav-sublabel">{tab.sublabel}</span>
            </span>
            {count !== undefined && count !== null ? (
              <span className="mpc-report-subnav-count">{count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  </div>
);

export default MonthlyPhoneReportNav;
